/* eslint-disable */
import * as React from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { filter, isArray } from 'lodash';
import { Icon } from '@iconify/react';
import { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions/order.action';
import * as PlantAction from '../actions/plant.action';
import * as PantryAction from '../actions/pantry.action';
import { server } from '../constants';
import keyboardreturn from '@iconify/icons-ic/keyboard-return';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Table,
  Grid,
  Card,
  Paper,
  Button,
  Checkbox,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  FormControl,
  OutlinedInput,
  Toolbar,
  TextField,
  MenuItem,
  Stack,
  Modal
} from '@mui/material';

import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { UserMoreMenu } from '../components/_dashboard/user';
import { CheckpickupListHead } from '../components/_dashboard/checkpickup';
// import CheckPickupList from '../_mocks_/checkpickup';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Swal from 'sweetalert2';
import Popup from 'reactjs-popup';
import SignaturePad from 'react-signature-canvas';
import styles from './styles.module.css';
import { isObject } from 'lodash';
import { imageUrlReceived } from '../constants';
import { SingleBed } from '@mui/icons-material';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'product_code', label: 'รหัสสินค้า', alignRight: false },
  { id: 'product_name', label: 'รายการสินค้า', alignRight: false },
  { id: 'qty', label: 'จำนวน', alignRight: false }
  // { id: 'rcv', label: 'จำนวนรับสินค้า', alignRight: false },
  // { id: '' }
];

// ----------------------------------------------------------------------

// function descendingComparator(a, b, orderBy) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1;
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1;
//   }
//   return 0;
// }

// function getComparator(order, orderBy) {
//   return order === 'desc'
//     ? (a, b) => descendingComparator(a, b, orderBy)
//     : (a, b) => -descendingComparator(a, b, orderBy);
// }

// function applySortFilter(array, comparator, query) {
//   const stabilizedThis = dataFilter.map((el, index) => [el, index]);
//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) return order;
//     return a[1] - b[1];
//   });
//   if (query) {
//     dataFilter = filter(dataFilter, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
//   }
//   return stabilizedThis.map((el) => el[0]);
// }
export function CheckPickup(props) {
  const navigate = useNavigate();
  const [plantList, setPlantList] = useState(null);
  const [pantryList, setPantryList] = useState(null);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(
    parseInt(localStorage.getItem(server.ROWS_PER_PAGE))
  );
  const [plantNo, setPlantNo] = useState('');
  const [pantryNo, setPantryNo] = useState('');
  const [deliverNumber, setDeliverNumber] = useState('');
  const [deliverDate, setDeliverDate] = useState('');
  const [deliverDT, setDeliverDT] = useState([]);
  const [DateDocumentvalue, setDateDocumentValue] = useState('');
  const [status, setStatus] = useState('');

  const showPlant = localStorage.getItem(server.LOGIN_PLANT);
  const showPantry = localStorage.getItem(server.LOGIN_PANTRY);

  const [imageShow, setImageShow] = useState(null);
  const [signatureImage, setSignatureImage] = useState(null); // create a state that will contain our image url
  const sigCanvas = useRef({});

  useEffect(() => {
    props.getPlants();
  }, []);

  useEffect(() => {
    props.getPantryByPlantNo(plantNo);
  }, [plantNo]);

  useEffect(() => {
    const { result } = props.plantReducer;
    // console.log(result);
    if (result) setPlantList(result);
  }, [props.plantReducer]);

  useEffect(() => {
    const { result } = props.pantryReducer;
    // console.log(result);
    if (result) setPantryList(result);
  }, [props.pantryReducer]);

  const { id } = useParams();

  if (id) {
    // alert(id);

    useEffect(() => {
      props.getOrderById(id);
    }, []);

    useEffect(() => {
      const { result } = props.orderReducer;

      if (result) {
        setPlantNo(result.plant_no);
        setPantryNo(result.pantry_no);
        setDeliverNumber(result.order_number);
        setDeliverDate(result.order_date);
        setStatus(result.status);
        setSignatureImage(result.signature_image);
      }
    }, [props.orderReducer]);

    useEffect(() => {
      props.getOrderDTById(id);
    }, []);

    useEffect(() => {
      const { result } = props.orderdtReducer;

      if (result && isArray(result)) {
        setDeliverDT(result);
      }
    }, [props.orderdtReducer]);
  }

  useEffect(() => {
    // console.log(signatureImage);
    //console.log('setImageShow');
    if (signatureImage) {
      // console.log(signatureImage.slice(0, 21));
      if (isObject(signatureImage)) {
        setImageShow(URL.createObjectURL(signatureImage));

        let data = new FormData();
        data.append('deliver_verify_by', localStorage.getItem(server.LOGIN_USERNAME));
        data.append('deliver_verify_date', Date());
        data.append('signature_image', signatureImage);
        data.append('status', status);
        data.append('plant_no', plantNo);

        if (id) {
          data.append('id', id);
          props.putCheckPickups(navigate, data, deliverDT);
        }
      } else if (signatureImage != '-' && signatureImage != '') {
        // console.log(`${imageUrlReceived}/${signatureImage}`);
        setImageShow(`${imageUrlReceived}/${signatureImage}`);
      }
    }
  }, [signatureImage]);

  const handleChangePlantNo = (event) => {
    setPlantNo(event.target.value);
    setPantryNo('');
  };

  const handleChangePantryNo = (event) => {
    setPantryNo(event.target.value);
  };

  const handleChangeDeliverNumber = (event) => {
    setOrderNumber(event.target.value);
  };

  const handleChangeDeliverDate = (event) => {
    setDeliverDate(event.toDate());
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = deliverDT.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangeQtyProduct = (event) => {
    let objIndex = deliverDT.findIndex((obj) => obj.id == event.target.id);
    // Edit Object in Array
    let arrProductList = [...deliverDT];
    arrProductList[objIndex] = { ...arrProductList[objIndex], rcv: event.target.value };
    setDeliverDT(arrProductList);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    localStorage.setItem(server.ROWS_PER_PAGE, event.target.value);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - deliverDT.length) : 0;

  // const filteredUsers = applySortFilter(CheckPickupList, getComparator(order, orderBy), filterName);

  // const isUserNotFound = filteredUsers.length === 0;

  const handleDateDocumentChange = (newValue) => {
    setDateDocumentValue(newValue.toDate());
  };

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  const [openSignature, setOpenSignature] = useState(false);
  const handleOpenSignature = () => setOpenSignature(true);
  const handleCloseSignature = () => setOpenSignature(false);

  const clear = () => sigCanvas.current.clear();
  const save = () => {
    if (!sigCanvas.current.isEmpty()) {
      setStatus('S');
      setSignatureImage(
        dataURLtoFile(sigCanvas.current.getTrimmedCanvas().toDataURL('image/png'), `${id}.png`)
      );
      // setSignatureImage(sigCanvas.current.getTrimmedCanvas().toDataURL('image/png'));
      setOpenSignature(false);

      // Swal.fire({
      //   position: 'center',
      //   icon: 'success',
      //   title: 'Save',
      //   showConfirmButton: false,
      //   timer: 1500
      // });
    }
  };

  return (
    <Page title="CheckPickup | JConnect">
      <Container maxWidth="false">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            ตรวจรับสินค้า
          </Typography>
          {!imageShow && (
            <Button variant="contained" onClick={handleOpenSignature}>
              ยืนยันตรวจรับสินค้า
            </Button>
          )}
          {imageShow && signatureImage && (
            <Button
              variant="contained"
              component={RouterLink}
              to={`/dashboard/checkproduct/${plantNo}`}
              startIcon={<Icon icon={keyboardreturn} />}
            >
              ย้อนกลับ
            </Button>
          )}

          <Modal
            // hideBackdrop
            open={openSignature}
            onClose={handleCloseSignature}
          >
            <div className={styles.container}>
              <div className={styles.sigContainer}>
                <SignaturePad canvasProps={{ className: styles.sigPad }} ref={sigCanvas} />
              </div>

              <div className={styles.pbuttons}>
                <Button variant="contained" className={styles.buttons} onClick={clear}>
                  ล้าง
                </Button>
                <Button variant="contained" className={styles.buttonSave} onClick={save}>
                  บันทึก
                </Button>
                <Button
                  variant="contained"
                  className={styles.buttons}
                  onClick={handleCloseSignature}
                >
                  ปิด
                </Button>
              </div>
            </div>
          </Modal>
        </Stack>

        <Grid container spacing={2} sx={{ mt: 3 }}>
          <Grid item lg={4} md={6} xs={12} container spacing={2}>
            <Grid item lg={12} md={12} xs={12}>
              <Box
                sx={{
                  borderRadius: 2,
                  border: 1,
                  borderColor: 'text.primary',
                  p: 3
                }}
              >
                <TextField
                  id="plantNo"
                  select
                  label="พื้นที่"
                  value={plantNo}
                  onChange={handleChangePlantNo}
                  sx={{ width: '100%', mt: 2, mb: 2 }}
                >
                  {plantList &&
                    plantList.map((option) => {
                      if (showPlant.indexOf(option.plant_no) >= 0 || showPlant.length === 0) {
                        return (
                          <MenuItem key={option.id} value={option.plant_no}>
                            {option.plant_no}
                          </MenuItem>
                        );
                      }
                    })}
                </TextField>
                <TextField
                  id="pantryNo"
                  select
                  label="ตึก"
                  value={pantryNo}
                  onChange={handleChangePantryNo}
                  sx={{ width: '100%', mt: 2, mb: 2 }}
                >
                  {pantryList &&
                    pantryList.map((option) => {
                      if (showPantry.length === 0 || showPantry.indexOf(option.pantry_no) >= 0)
                        return (
                          <MenuItem key={option.id} value={option.pantry_no}>
                            {option.pantry_no}
                          </MenuItem>
                        );
                    })}
                </TextField>
              </Box>
            </Grid>
            <Grid item lg={12} md={12} xs={12}>
              <Box
                sx={{
                  borderRadius: 2,
                  border: 1,
                  borderColor: 'text.primary',
                  p: 3
                }}
              >
                <TextField
                  id="deliverNumber"
                  label="เลขที่เอกสาร"
                  sx={{ width: '100%', mt: 2, mb: 2 }}
                  value={deliverNumber}
                  onChange={handleChangeDeliverNumber}
                ></TextField>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Stack>
                    <DatePicker
                      label="วันที่เอกสาร"
                      inputFormat="DD/MM/YYYY"
                      value={(DateDocumentvalue, deliverDate)}
                      onChange={(handleDateDocumentChange, handleChangeDeliverDate)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Stack>
                </LocalizationProvider>
              </Box>
            </Grid>

            {imageShow && signatureImage && (
              <Grid item lg={12} md={12} xs={12}>
                <Box
                  sx={{
                    borderRadius: 2,
                    border: 1,
                    borderColor: 'text.primary',
                    p: 3
                  }}
                >
                  <img src={imageShow} alt={signatureImage.name} />
                </Box>
              </Grid>
            )}
          </Grid>

          <Grid item lg={8} md={6} xs={12}>
            <Box
              sx={{
                border: 1,
                borderRadius: 2,
                borderColor: 'text.primary',
                p: 3
              }}
            >
              <>
                <Scrollbar>
                  <TableContainer sx={{ minWidth: 400 }}>
                    <Table>
                      <CheckpickupListHead
                        order={order}
                        orderBy={orderBy}
                        headLabel={TABLE_HEAD}
                        rowCount={deliverDT.length}
                        numSelected={selected.length}
                        onRequestSort={handleRequestSort}
                        onSelectAllClick={handleSelectAllClick}
                      />
                      <TableBody>
                        {deliverDT
                          // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((row) => {
                            const { id, product_name, product, qty, rcv } = row;
                            const isItemSelected = selected.indexOf(id) !== -1;

                            return (
                              <TableRow
                                hover
                                key={id}
                                tabIndex={-1}
                                role="checkbox"
                                selected={isItemSelected}
                                aria-checked={isItemSelected}
                              >
                                <TableCell padding="checkbox">
                                  <Checkbox
                                    checked={isItemSelected}
                                    onChange={(event) => handleClick(event, id)}
                                  />
                                </TableCell>
                                <TableCell align="left">{product.product_code}</TableCell>
                                <TableCell align="left">{product_name}</TableCell>
                                <TableCell align="left">{qty}</TableCell>
                                {/* <TableCell align="left">
                                  <TextField
                                    inputProps={{
                                      // step: 1,
                                      min: 0,
                                      max: 99999,
                                      type: 'number'
                                    }}
                                    id={id}
                                    value={rcv}
                                    onChange={handleChangeQtyProduct}
                                    align="right"
                                    onWheel={(e) => e.target.blur()}
                                  />
                                </TableCell> */}
                              </TableRow>
                            );
                          })}
                        {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                          </TableRow>
                        )}
                      </TableBody>
                      {/* {isUserNotFound && (
                        <TableBody>
                          <TableRow>
                            <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                              <SearchNotFound searchQuery={filterName} />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      )} */}
                    </Table>
                  </TableContainer>
                </Scrollbar>

                {/* <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={deliverDT.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                /> */}
              </>

              {/* <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row-reverse',
                  //   p: 1,
                  mt: 2,
                  bgcolor: 'background.paper'
                }}
              >
                <Button variant="contained" component={RouterLink} to="/dashboard/checkproduct">
                  ยกเลิก
                </Button>
                <Button
                  variant="contained"
                  sx={{ mr: 2 }}
                  onClick={() => {
                    let data = new FormData();
                    data.append('deliver_verify_by', localStorage.getItem(server.LOGIN_USERNAME));
                    data.append('deliver_verify_date', Date());
                    data.append('signature_image', signatureImage);
                    data.append('status', status);
                    data.append('plant_no', plantNo);

                    if (id) {
                      data.append('id', id);
                      props.putCheckPickups(navigate, data, deliverDT);
                    }

                    // const postplant = props.postPlants(navigate, data);
                    // postplant(dispatch);

                    Swal.fire({
                      position: 'center',
                      icon: 'success',
                      title: 'Save',
                      showConfirmButton: false,
                      timer: 1500
                    });
                  }}
                >
                  บันทึก
                </Button>
              </Box> */}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}

const mapStateToProps = ({ orderReducer, orderdtReducer, pantryReducer, plantReducer }) => ({
  orderReducer,
  orderdtReducer,
  pantryReducer,
  plantReducer
});

const mapDispatchToProps = {
  ...actions,
  ...PlantAction,
  ...PantryAction
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckPickup);
